import React from "react";
import { Route, Redirect } from "react-router-dom";
import HelpDeskLayout from "../layouts/HelpDeskLayout";
import _authService from "modules/AuthService.js";
import NetworkDetector from "../HOC/NetworkDetector";

const HelpDeskRoute = ({ component: Component, layout: Layout, role: role, menuId: menuId, ...rest }) => (
    <Route key={Math.floor((Math.random() * 9999999) + 1)} {...rest} render={props => (
        //Also check role
        _authService.isHelpDeskAdminAuthenticated()
            ?
            <HelpDeskLayout componentName={menuId}>
                <Component {...props} />
            </HelpDeskLayout>
            :
            <Redirect to={{
                pathname: '/helpDeskAdmin/login'
            }} />
    )} />
)

export default NetworkDetector(HelpDeskRoute)